export const ChallengeTypes = Object.freeze({
    LONG_TERM_WORKOUT_COUNT: { translationKey: "challenges:longTermWorkoutCount", descriptionKey:"challenges:longTermWorkoutCountDescription"},
    LONG_TERM_TIMED: { translationKey: "challenges:longTermTimed", descriptionKey:"challenges:longTermTimedDescription"},
});

const challengeTypesMapping = {
    "long_term_workout_count": ChallengeTypes.LONG_TERM_WORKOUT_COUNT,
    "long_term_timed": ChallengeTypes.LONG_TERM_TIMED,
};

export function mapChallengeType(apiChallengeTypeName) {
    return challengeTypesMapping[apiChallengeTypeName] || null;
}